import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import LoadingScreen from "../components/SignUp/LoadingScreen";

const PrivateRoute = ({ isAuthenticated }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isAuthenticated !== null) {
      setIsLoading(false); // Fine del caricamento non appena lo stato di autenticazione è definito
    }
  }, [isAuthenticated]);

  if (isLoading) return <LoadingScreen />; // Visualizzazione del caricamento durante la verifica

  return isAuthenticated ? <Outlet /> : <Navigate to="/signin" replace />;
};

export default PrivateRoute;
